import { MouseEvent } from 'react';
import Inventory from '../../../../entities/Inventory';
import style from './Result.module.css';
import { translate } from '../../../../helpers/translations';

interface ResultPropsInterface {
  inventory: Inventory;
  onInventorySelected: (inventory: Inventory) => void;
}

export default function Result(props: ResultPropsInterface) {
  const {
    inventory,
    onInventorySelected,
  } = props;

  const handleClick = (event: MouseEvent) => {
    event.preventDefault();

    if (inventory.canBeTraded) {
      onInventorySelected(inventory);
    }
  };

  const tradeInStyle = inventory.canBeTraded ? 'canBeTraded' : 'cantBeTraded';

  return (
    <div
      className={`${style.container} ${style[tradeInStyle]}`}
      onClick={handleClick}
      role="presentation"
    >
      <div className={style.image}>
        <img src={inventory.image} alt={inventory.title} />

      </div>
      <div className={style.details}>
        {inventory.title}
        {inventory.canBeTraded ? null : (
          <div className={style.cantBeTradedNotice}>
            {translate('LYT_SECONDHAND_NOT_AVAILABLE_TO_TRADE_IN')}
          </div>
        )}
      </div>
    </div>
  );
}
